import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-esr-summary',
    imports: [CommonModule, RouterModule],
    templateUrl: './esr-summary.component.html',
    styleUrl: './esr-summary.component.scss'
})
export class EsrSummaryComponent {
  request: string = 'open';
  deviceData: any = {};
  deviceData$: any = null;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }
}
